// extracted by mini-css-extract-plugin
export default {"container":"Recommend_container__hkdiN","hide":"Recommend_hide__NrHhL","Cards":"Recommend_Cards__yVH0F","title":"Recommend_title__u-RYH"};